/* eslint-disable camelcase */
import { PAK_ADJUSTED_QUANTITY } from "../../../constants/eventadjustments";
import { PORTIONPAK, SMARTPAK } from "../../../constants/producttypes";
import { roundedToFixed } from "../../../utils/number";
import * as paymentMethods from "../../../views/shared/paymentmethods";

function convertPaymentMethod(paymentMethod) {
    if (paymentMethod === paymentMethods.CreditCard) {
        return 'credit card';
    }

    if (paymentMethod === paymentMethods.PayPal) {
        return 'paypal';
    }

    if (paymentMethod === paymentMethods.ApplePay) {
        return 'applepay';
    }

    return 'unknown';
}

function booleanToYesNo(value) {
    return typeof value === 'boolean' && value ? 'yes' : 'no';
}

export function formatCartItemsForEvents(items) {
    if (!Array.isArray(items)) {
        throw new Error('formatCartItemsForEvents requires an array of items as an argument.');
    }

    const format = ({
        IsAutoShip,
        Brand,
        ProductId,
        ProductClassId,
        ProductClassName,
        ParentReportingCategory,
        ChildReportingCategory,
        Quantity,
        Price,
        ProductType,
        Discounts
    }) => {
        return {
            item_name: ProductClassName,
            item_id: (ProductClassId + 10000).toString(),
            item_variant: ProductId.toString(),
            item_brand: Brand,
            item_parent_reporting_category: ParentReportingCategory,
            item_child_reporting_category: ChildReportingCategory,
            item_autoship: booleanToYesNo(IsAutoShip),
            item_smartpak: booleanToYesNo(ProductType === SMARTPAK),
            price: Price.toString(),
            quantity: Quantity.toString(),
            coupon: Object.keys(Discounts || {}),
        };
    };

    return items
        .reduce((arr, item) => {
            const { IsAutoShip, SupplementViewModels, ProductType } = item;

            if (ProductType === SMARTPAK || item.ProductType === PORTIONPAK) {
                SupplementViewModels.forEach(product => {
                    arr.push(format({
                        ...product,
                        Price: roundedToFixed(product.DiscountedPrice, 2),
                        ProductType,
                        IsAutoShip,
                        Quantity: PAK_ADJUSTED_QUANTITY
                    }));
                });
            } else {
                arr.push(format({
                    ...item,
                    Price: roundedToFixed(item.DiscountedUnitPrice, 2),
                    ProductType,
                    IsAutoShip
                }));
            }

            return arr;
        }, []);
}

export function formatConfirmationModel({ CostSummary, OrderId, IsNewCustomer, ShippingService, PaymentMethod, CartItems }) {
    const { OrderTotal, DiscountSum, Discounts, Tax, Shipping } = CostSummary; 

    return {
        value: OrderTotal?.replace('$', ''),
        transaction_id: OrderId.toString(),
        coupon: Object.keys(Discounts),
        discount: DiscountSum?.replace('$', ''),
        tax: Tax?.replace('$', ''),
        shipping: Shipping?.replace('$', ''),
        shipping_tier: ShippingService,
        payment_type: convertPaymentMethod(PaymentMethod),
        customer_type: IsNewCustomer ? 'new' : 'existing',
        items: formatCartItemsForEvents(CartItems)
    };
}
